import { Dispatch, SetStateAction } from 'react'
import { Dialog, DialogContent, DialogTitle } from '@mui/material'

interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  terminarVideo: () => void;
};

const ModalConfirmacion = ({ isOpen, setIsOpen, terminarVideo }: Props) => {
  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} >
      <DialogTitle> <p className='text-center text-2xl font-semibold mb-0'>¿Estás seguro de continuar?</p></DialogTitle>
      <DialogContent>
        <p className='text-center font-medium'>Asegurate de haber terminado de ver el video de inicio para comprender como funciona el programa</p>
        <div
          className="flex items-center justify-center gap-4"
        >
          <button  
            className="font-bold m-0 py-2 cursor-pointer text-slate-800 shadow-md rounded-lg bg-yellowTr4iner px-[30px] flex items-center gap-1 disabled:opacity-65 disabled:cursor-default"
            // disabled={ currentPosition === 0 ? true : false }
            onClick={terminarVideo}
          >
            Vamos
          </button>     
          <button
            className="font-bold m-0 py-2 cursor-pointer text-slate-800 shadow-md rounded-lg bg-red-500 px-[30px] flex items-center gap-1 disabled:opacity-65 disabled:cursor-default"
            onClick={() => setIsOpen(false)}
          >
            Cancelar
          </button>
        </div>     
      </DialogContent>
    </Dialog>
  )
}

export default ModalConfirmacion;
